var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mode-picker-cont" }, [
    _c(
      "div",
      {
        staticClass: "theme-mode",
        class: _vm.$vuetify.theme.dark ? "theme_dark active" : "theme_light",
        on: {
          click: function ($event) {
            return _vm.selectThemeMode(true)
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "theme-mode__title",
            class: _vm.$vuetify.theme.dark ? "theme_dark" : "theme_light",
          },
          [_vm._v(" Dark ")]
        ),
        _c(
          "div",
          { staticClass: "theme-mode__icon" },
          [
            _c("v-icon", { attrs: { "x-large": "" } }, [
              _vm._v(" far fa-moon "),
            ]),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "theme-mode",
        class: _vm.$vuetify.theme.dark ? "theme_dark" : "theme_light active",
        on: {
          click: function ($event) {
            return _vm.selectThemeMode(false)
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "theme-mode__title",
            class: _vm.$vuetify.theme.dark ? "theme_dark" : "theme_light",
          },
          [_vm._v(" Light ")]
        ),
        _c(
          "div",
          { staticClass: "theme-mode__icon" },
          [
            _c("v-icon", { attrs: { "x-large": "" } }, [
              _vm._v(" far fa-sun "),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }